/** Alinhado a server/src/constants/superAdmins.ts */
export const SUPER_ADMIN_EMAILS = [
  'mario@agradadigital.com.br',
  'marcio.cerutti@agradadigital.com.br',
  'douglas@agradadigital.com.br',
  'doug@agradadigital.com.br',
] as const

function extraSuperAdminEmails(): string[] {
  return String(import.meta.env.VITE_SUPER_ADMIN_EMAILS || '')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean)
}

export function isSuperAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false
  const normalized = email.trim().toLowerCase()
  return (
    (SUPER_ADMIN_EMAILS as readonly string[]).includes(normalized) ||
    extraSuperAdminEmails().includes(normalized)
  )
}

/** Super admin = ADMIN + e-mail na lista. */
export function isSuperAdmin(user: { role?: string | null; email?: string | null } | null | undefined): boolean {
  if (!user) return false
  return String(user.role ?? '').toLowerCase() === 'admin' && isSuperAdminEmail(user.email)
}
